const constants = {};

constants.PAGE = {
  LIST_SIZE: 20,
}

constants.KB = {
  IS_DOCBRAIN_OFF: process.env.DOCBRAIN_STATUS === 'off' ? true : false,
  DOCBRAIN_WITHOUT_LLM: process.env.DOCBRAIN_STATUS === 'without_llm' ? true : false,
}

module.exports = constants;